<footer>
    <div class="footer-top">
       <div class="title">
          <span>Powered by</span>
          <div class="logo-container">
             <img src="assets/icons/cue-logo-blue.png">
          </div>
       </div>
    </div>
    <div class="g-section-container">
       <div class="footer-section">
          <!-- <div class="site-map-links">
             <a>CUE Help & Support</a>
             <a>Terms & Conditions</a>
             <a>Customer Service</a>
             <a>Privacy Policy</a>
             <a>Terms of Sale</a>
          </div> -->
       </div>
       <div class="footer-bottom">
          <div class="copyright">{{'@'}} {{currentYear}} All Rights Reserved</div>
       </div>
    </div>
 </footer>